import { createSlice } from '@reduxjs/toolkit';

export interface LeadershipInformationInterface {
  principalsResume: {
    id: string;
    resume: { name: string; type: string; size: number };
  }[];
  racialEthnicGroup: string[];
  majorityOwnership: string[];
  boardOfDirectorsPercent: { [key: string]: string };
  leadershipInfoIsValid: boolean;
}

const initialState: LeadershipInformationInterface = {
  principalsResume: [],
  racialEthnicGroup: [],
  majorityOwnership: [],
  boardOfDirectorsPercent: {
    communityMembersPercent: '',
    hispanicLatinxPercent: '',
    blackAfricanAmericanPercent: '',
    asianPacificIslandersPercent: '',
    nativeAmericanPercent: '',
    whiteCaucasianPercent: '',
    multiRacialPercent: '',
  },
  leadershipInfoIsValid: false,
};

export const leadershipInformationSlice = createSlice({
  name: 'leadershipInformation',
  initialState,
  reducers: {
    clearLeadershipInfo: (_state) => initialState,
    setLeadershipInformation(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setLeadershipInformation, clearLeadershipInfo } = leadershipInformationSlice.actions;
export default leadershipInformationSlice.reducer;
